/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const HideCodeEditorFiletreeControlsWithOnlyQuizStepsSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('HIDE_CODE_EDITOR_FILETREE_CONTROLS_WITH_ONLY_QUIZ_STEPS'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return HideCodeEditorFiletreeControlsWithOnlyQuizStepsSettingParser.decode(input).map(res => new HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting(res));
    }
    static unsafeDecode(input) {
        return HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return HideCodeEditorFiletreeControlsWithOnlyQuizStepsSettingParser.encode(data);
    }
    static schema() {
        return HideCodeEditorFiletreeControlsWithOnlyQuizStepsSettingParser.schema();
    }
}
